import { useGate, useStoreMap } from 'effector-react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  LoadingBlock,
  BookingCar,
  bookingCarModel,
} from '~/features/BookingCars/BookingCar'
import { entityBookingCarModel } from '~/entities/BookingCar'
import { viewerModel } from '~/entities/viewer'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { NotFound } from '~/shared/ui/NotFound'
import { PageContainer } from '~/shared/ui/PageContainer'
import { useEvents, YM_KEYS_ENUM } from '~/shared/ui/YandexMetrika'

export const BookingCarPage = () => {
  const authenticated = viewerModel.useAuthenticated()
  const { ymEvent } = useEvents()

  const params = useParams<{ bookingCarId: UniqueId }>()
  const paramsBookingCarId = params.bookingCarId as UniqueId

  useGate(bookingCarModel.Gate, { id: paramsBookingCarId })

  const bookingCarId = useStoreMap(bookingCarModel.$bookingCar, (bookingCar) =>
    bookingCar?.getApiId(),
  )
  const bookingCarTitle = useStoreMap(
    bookingCarModel.$bookingCar,
    (bookingCar) => `${bookingCar?.getBrand()} ${bookingCar?.getModel()}`,
  )
  const bookingCarLoaded = bookingCarId === paramsBookingCarId
  const title = `${bookingCarLoaded ? bookingCarTitle : ''}`

  const displayName = bookingCarLoaded ? (
    bookingCarTitle
  ) : (
    <ProgressBlock height={20} size={16} />
  )

  const bookingCarError =
    entityBookingCarModel.useBookingCarError(paramsBookingCarId)

  useEffect(() => {
    ymEvent(
      authenticated
        ? YM_KEYS_ENUM.booking_car_card_view_auth
        : YM_KEYS_ENUM.booking_car_card_view_un_auth,
    )
  }, [authenticated, ymEvent])

  if (bookingCarError) {
    return <NotFound message='Не удалось загрузить автомобиль' />
  }

  return (
    <PageContainer title={title} backTitle={displayName} canBack>
      {bookingCarLoaded ? <BookingCar /> : <LoadingBlock />}
    </PageContainer>
  )
}
